import { Pipe, PipeTransform } from '@angular/core';
import { ShoppingCartItem } from '@app/store/shopping-cart';

@Pipe({
    name: 'totalGross',
})
export class PriceTotalGrossPipe implements PipeTransform {
    transform(cartItems: ShoppingCartItem[] | null): number | null {
        return (
            cartItems?.reduce((total, { qtyPerUnit, product, qty }) => {
                const value = qtyPerUnit ? product.defaultDiscountPrice * (1 + product.vatRate / 100) * qty * qtyPerUnit : 0;

                return total + value;
            }, 0) ?? null
        );
    }
}
